module.exports = __webpack_public_path__ + "fdafa04c.webp";